// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"4616f26b","533":"f43ea240","646":"d7a922e5"}[chunkId] + ".chunk.js";
};